import React from 'react'
import Content from './ui/partials/Content'
import PageTitle from '../../../../components/_refactored/PageTitle/PageTitle'
import { useTranslation } from 'react-i18next'

const BillingPlans = () => {
  const { t: g } = useTranslation('general')

  return (
    <>
      <PageTitle name={g('pageName.billingPlans')} />
      <Content />
    </>
  )
}

export default BillingPlans
